import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { ILuxuryHome } from '@share/common-types';

import './style.scss';

interface IProps {
  home: ILuxuryHome;
  highlightsRef: React.RefObject<HTMLDivElement>;
}

export const LuxuryHomesDetailsActivities: React.FC<IProps> = ({ home, highlightsRef }) => {

  const [showMoreActivities, setShowMoreActivities] = useState(false);

  if (!home?.activities?.length) {
    return null
  };

  return (  
    <section id="highlights" className="property-section" ref={highlightsRef}>
      <h2>Highlights</h2>

      <ul>
        {home?.activities?.slice(0, showMoreActivities ? home?.activities?.length : 3).map((a: any) => (
          <li key={a.name}><FontAwesomeIcon icon={faCircle} style={{ color: '#8B6F40', marginRight: 10, fontSize: 8 }} /> {a.name} {a.distanceInMiles && <span className="proximity"> - {a.distanceInMiles} miles</span>}</li>
        ))}
      </ul>

      {home?.activities?.length > 3 &&
        <button className="read-more" onClick={() => setShowMoreActivities(!showMoreActivities)}>
          Read {showMoreActivities ? 'less' : 'more'}
        </button>}
    </section>
  );
};
